<app-loader-circles *ngIf="showLoader"></app-loader-circles>

<app-new-modal-message
  #modalAvisos
  [showFecharBtn]="false"
></app-new-modal-message>

<div class="position-relative">
  <form [formGroup]="demaisDadosForm" class="forms">
    <div class="row">
      <div class="row info-container white-box">
        <h2>Demais dados</h2>
        <app-panel-custom
          title="Verificação de Biometria do Cliente"
          color="blue"
        >
          <div class="panel-content">
            <div class="subtitle" *ngIf="!hasBiometria">
              <span class="icon thumbs-down"></span>
              <span
                >O cliente não realizou todas as etapas <br />
                da verificação de privacidade e biometria.</span
              >
            </div>
            <div class="subtitle" *ngIf="hasBiometria">
              <span class="icon thumbs-up"></span>
              <span
                >O cliente realizou todas as etapas da verificação de
                <br />privacidade e biometria. A Clearsale já validou as
                <br />informações enviadas, podemos continuar a proposta.</span
              >
            </div>

            <div *ngIf="!hasBiometria" class="resend-btn">
              <a
                class="bt-back btn btn-border-orange"
                (click)="resendSMS()"
                [ngClass]="{ disabled: !resendCodeEnable }"
              >
                <span class="fa fa-envelope"></span>
                <span *ngIf="resendCodeEnable"> Reenviar Link ao cliente</span>
                <span *ngIf="!resendCodeEnable">
                  Reenviar em
                  <countdown
                    #countdown
                    [config]="{ leftTime: countdownTime, format: 'ss' }"
                    (event)="handleCountdownEvent($event)"
                  ></countdown
                  >s
                </span>
              </a>
              <a
                class="modal-anchor"
                *ngIf="!hasBiometria"
                (click)="openNotReceivedModal()"
                >O cliente não recebeu o link?</a
              >
            </div>

            <div class="warning" *ngIf="!hasBiometria">
              <span class="icon warning"></span>
              <div class="text">
                <span class="text-orange">ATENÇÃO:</span> Precisamos garantir
                que o cliente confirme as permissões de LGPD, SCR e tire uma
                foto do seu rosto (selfie).<span class="text-red"
                  >Esta etapa é obrigatória e não será possível finalizar a
                  proposta sem as autorizações e foto do cliente.</span
                >
              </div>
            </div>
          </div>
        </app-panel-custom>

        <app-panel-custom [title]="tituloPainel" color="blue">
          <div>
            <app-mercadoria
              [index]="produto"
              [indentificacaoForm]="demaisDadosForm"
              [valorDisabled]="valorDisabled"
              [valorLiquido]="proposta.valorLiquido"
              (selfDestructEmitter)="destroyProduto($event)"
              *ngFor="let produto of filterProdutos()"
            ></app-mercadoria>
            <div class="form-group show-total pb-0">
              <div class="inputs">
                <label for="valorTotalProdutos">Valor Total dos Produtos</label>
                <input
                  class="form-control d-none"
                  type="text"
                  placeholder="R$ 00.000,00"
                  formControlName="valorTotalProdutos"
                  name="valorTotalProdutos"
                  readonly
                />
                <p>{{ valorTotalProdutos | currency: 'BRL':'symbol' }}</p>
              </div>
            </div>
            <div class="form-group show-total pb-0">
              <div class="inputs">
                <label for="valorSolicitado">Valor Solicitado</label>
                <input
                  class="form-control d-none"
                  type="text"
                  placeholder="R$ 00.000,00"
                  formControlName="valorSolicitado"
                  name="valorSolicitado"
                  readonly
                />
                <p>{{ valorSolicitado | currency: 'BRL':'symbol' }}</p>
              </div>
            </div>

            <div
              *ngIf="!valorMercadoriasIgualSolicitado"
              class="alert alert-danger alert-dismissable"
            >
              <strong
                >Valor total dos produtos diferente do valor solicitado!
              </strong>
            </div>
          </div>
        </app-panel-custom>

        <h2>Observações</h2>
        <div class="textarea-observacoes white-box">
          <textarea
            rows="10"
            cols="90"
            maxlength="4000"
            name="observacoes"
            formControlName="observacoes"
          ></textarea>
        </div>
      </div>
    </div>
  </form>

  <app-botao-navegacao
    *ngIf="!showTryAgainButton"
    (previous)="onClickPrevious()"
    (next)="onClickNext()"
    [previousShow]="true"
    [nextShow]="true"
    nextLabel="Analisar"
    [nextEnabled]="valid"
  ></app-botao-navegacao>

  <div class="btn-analisar-novamente">
    <button
      *ngIf="showTryAgainButton"
      class="bt-go btn btn-full-orange"
      (click)="onClickTryAgain()"
      [disabled]="!valid"
    >
      Analisar novamente
    </button>
  </div>

  <div class="loader-phases" *ngIf="showLoaderPhases">
    <app-loader-phases
      [phases]="['Aguarde, validando informações.']"
    ></app-loader-phases>
  </div>
</div>
